import { render, staticRenderFns } from "./DisplayAvatar.vue?vue&type=template&id=38bd8f50&scoped=true"
import script from "./DisplayAvatar.vue?vue&type=script&lang=js"
export * from "./DisplayAvatar.vue?vue&type=script&lang=js"
import style0 from "./DisplayAvatar.vue?vue&type=style&index=0&id=38bd8f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd8f50",
  null
  
)

export default component.exports